import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Table,
} from "reactstrap";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Row,
} from "../../components/Component";
import RTag from "../../components/tags/ReactTag";
import { getConfig } from "../../config";
import { GET, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { COMPANY_CODE, SETTING_KEY } from "../../utils/Utils";
const { company } = getConfig();
const Setting = () => {
  const [loading, setLoading] = useState(false);
  const [userOptions, setUserOptions] = useState([]);

  const formAssignReviewerBill = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignReviewerTransactionHistory = useForm({
    defaultValues: {
      content: []
    },
  });

  const formTags = useForm({
    defaultValues: {
      content: []
    },
  });

  const formFoodAllowance = useForm({
    defaultValues: {
      content: 0,
    },
  });

  const formExtraHourFoodAllowance = useForm({
    defaultValues: {
      content: 0,
    },
  });

  const formOilRefiningAllowance = useForm({
    defaultValues: {
      content: 0,
    },
  });

  const formWorkingDayPerMonth = useForm({
    defaultValues: {
      content: 0,
    },
  });

  const formWorkingDayDriverPerMonth = useForm({
    defaultValues: {
      content: 0,
    },
  });

  const formMinWorkingDayToReceivedFullAllowance = useForm({
    defaultValues: {
      content: 0,
    },
  });

  const formMinWorkingDayOilRefiningToReceivedFullAllowance = useForm({
    defaultValues: {
      content: 0,
    },
  });


  const formAssignReviewerPNTransactionHistory = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignReviewerPNCustomerMoneyFlow = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignReviewerPNStaffMoneyFlow = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignReviewerInventory = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignApproverMaterial = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignConfirmMaterial = useForm({
    defaultValues: {
      content: []
    },
  });

  const formAssignReviewerIngredientPriceHistory = useForm({
    defaultValues: {
      content: []
    },
  });

  const formHandlerExternalContract = useForm({
    defaultValues: {
      content: []
    },
  });

  const formHandlerIngredientPriceHistory = useForm({
    defaultValues: {
      content: []
    },
  });

  const formDefaultCommissionIngredientFeeExport = useForm({
    defaultValues: {
      content: {
        BHD: 15,
        DTP: 35,
      }
    },
  });

  useEffect(() => {
    GET("/user", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });


    GET("/setting", {}, true).then(({ data }) => {
      data.forEach(({ content, key }) => {
        if (key === SETTING_KEY.ASSIGN_REVIEWER_BILL) {
          formAssignReviewerBill.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_REVIEWER_TRANSACTION_HISTORY) {
          formAssignReviewerTransactionHistory.reset({ content })
        }

        if (key === SETTING_KEY.TAGS) {
          formTags.reset({ content })
        }

        if (key === SETTING_KEY.FOOD_PER_SHIFT_ALLOWANCE) {
          formFoodAllowance.reset({ content })
        }


        if (key === SETTING_KEY.EXTRA_HOUR_FOOD_PER_SHIFT_ALLOWANCE) {
          formExtraHourFoodAllowance.reset({ content })
        }

        if (key === SETTING_KEY.OIL_REFINING_PER_SHIFT_ALLOWANCE) {
          formOilRefiningAllowance.reset({ content })
        }

        if (key === SETTING_KEY.WORKING_DAY_PER_MONTH) {
          formWorkingDayPerMonth.reset({ content })
        }
        if (key === SETTING_KEY.WORKING_DAY_DRIVER_PER_MONTH) {
          formWorkingDayDriverPerMonth.reset({ content })
        }

        if (key === SETTING_KEY.MIN_WORKING_DAY_TO_RECEIVED_FULL_ALLOWANCE) {
          formMinWorkingDayToReceivedFullAllowance.reset({ content })
        }

        if (key === SETTING_KEY.MIN_WORKING_DAY_OF_OIL_REFINING_TO_RECEIVED_FULL_ALLOWANCE) {
          formMinWorkingDayOilRefiningToReceivedFullAllowance.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_REVIEWER_PN_TRANSACTION_HISTORY) {
          formAssignReviewerPNTransactionHistory.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_REVIEWER_PN_CUSTOMER_MONEY_FLOW) {
          formAssignReviewerPNCustomerMoneyFlow.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_REVIEWER_PN_STAFF_MONEY_FLOW) {
          formAssignReviewerPNStaffMoneyFlow.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_REVIEWER_INVENTORY) {
          formAssignReviewerInventory.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_APPROVE_MATERIAL) {
          formAssignApproverMaterial.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_CONFIRM_MATERIAL) {
          formAssignConfirmMaterial.reset({ content })
        }

        if (key === SETTING_KEY.ASSIGN_REVIEWER_INGREDIENT_PRICE_HISTORY) {
          formAssignReviewerIngredientPriceHistory.reset({ content })
        }

        if (key === SETTING_KEY.HANDLER_EXTERNAL_CONTRACT) {
          formHandlerExternalContract.reset({ content })
        }

        if (key === SETTING_KEY.HANDLER_INGREDIENT_PRICE_HISTORY) {
          formHandlerIngredientPriceHistory.reset({ content })
        }

        if (key === SETTING_KEY.DEFAULT_COMMISSION_INGREDIENT_FEE_EXPORT) {
          formDefaultCommissionIngredientFeeExport.reset({ content })
        }
      })
    })
  }, [])
  // Submits form data
  const onHandleSubmitSetting = ({ content }, key) => {
    setLoading(true);
    PUT(`/setting/${key}`, { content }, {}, true)
      .then(() => {
        toast.success("Cập nhật thành công");
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Head title="Cài đặt"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Cài đặt</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Row>
          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Kiểm duyệt đơn
              </CardHeader>
              <CardBody>
                <form onSubmit={formAssignReviewerBill.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_BILL))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người kiểm duyệt<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formAssignReviewerBill.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formAssignReviewerBill.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Kiểm duyệt thu chi
              </CardHeader>
              <CardBody>
                <form onSubmit={formAssignReviewerTransactionHistory.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_TRANSACTION_HISTORY))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người kiểm duyệt<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formAssignReviewerTransactionHistory.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formAssignReviewerTransactionHistory.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Trợ cấp tiền ăn mỗi ca
              </CardHeader>
              <CardBody>
                <form onSubmit={formFoodAllowance.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.FOOD_PER_SHIFT_ALLOWANCE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Số tiền <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formFoodAllowance.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formFoodAllowance.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Trợ cấp tiền ăn tăng ca
              </CardHeader>
              <CardBody>
                <form onSubmit={formExtraHourFoodAllowance.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.EXTRA_HOUR_FOOD_PER_SHIFT_ALLOWANCE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Số tiền <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formExtraHourFoodAllowance.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formExtraHourFoodAllowance.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Trợ cấp nấu dầu
              </CardHeader>
              <CardBody>
                <form onSubmit={formOilRefiningAllowance.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.OIL_REFINING_PER_SHIFT_ALLOWANCE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Số tiền <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formOilRefiningAllowance.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formOilRefiningAllowance.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Số ngày làm việc trong tháng
              </CardHeader>
              <CardBody>
                <form onSubmit={formWorkingDayPerMonth.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.WORKING_DAY_PER_MONTH))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Số ngày <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formWorkingDayPerMonth.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formWorkingDayPerMonth.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Số ngày làm việc tối thiểu để hưởng đủ trợ cấp
              </CardHeader>
              <CardBody>
                <form onSubmit={formMinWorkingDayToReceivedFullAllowance.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.MIN_WORKING_DAY_TO_RECEIVED_FULL_ALLOWANCE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Số ngày <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formMinWorkingDayToReceivedFullAllowance.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formMinWorkingDayToReceivedFullAllowance.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>
          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Số ngày làm việc tối thiểu cn nấu dầu để hưởng đủ trợ cấp
              </CardHeader>
              <CardBody>
                <form onSubmit={formMinWorkingDayOilRefiningToReceivedFullAllowance.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.MIN_WORKING_DAY_OF_OIL_REFINING_TO_RECEIVED_FULL_ALLOWANCE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Số ngày <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formMinWorkingDayOilRefiningToReceivedFullAllowance.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formMinWorkingDayOilRefiningToReceivedFullAllowance.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Kiểm duyệt thu chi cty Phương Nam
              </CardHeader>
              <CardBody>
                <form onSubmit={formAssignReviewerPNTransactionHistory.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_PN_TRANSACTION_HISTORY))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người kiểm duyệt<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formAssignReviewerPNTransactionHistory.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formAssignReviewerPNTransactionHistory.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>



          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Chốt công nợ vật tư
              </CardHeader>
              <CardBody>
                <form onSubmit={formAssignConfirmMaterial.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_CONFIRM_MATERIAL))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người chốt công nợ<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formAssignConfirmMaterial.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formAssignConfirmMaterial.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Kiểm duyệt nhiên liệu
              </CardHeader>
              <CardBody>
                <form onSubmit={formAssignReviewerInventory.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_INVENTORY))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người kiểm duyệt<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formAssignReviewerInventory.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formAssignReviewerInventory.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Nhãn
              </CardHeader>
              <CardBody>
                <form onSubmit={formTags.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.TAGS))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Nhãn <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formTags.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RTag
                                tags={value.map(e => ({
                                  id: e,
                                  text: e
                                }))}
                                handleDelete={(index) => {
                                  const newValue = [...value];
                                  newValue.splice(index, 1)
                                  onChange(newValue)
                                }}
                                handleAddition={(tag) => {
                                  if (!value.includes(tag.id)) {
                                    const newValue = [...value];
                                    newValue.push(tag.id)
                                    onChange(newValue)
                                  }
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formTags.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Kiểm duyệt đơn giá nguyên liệu
              </CardHeader>
              <CardBody>
                <form onSubmit={formAssignReviewerIngredientPriceHistory.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_INGREDIENT_PRICE_HISTORY))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người kiểm duyệt<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formAssignReviewerIngredientPriceHistory.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formAssignReviewerIngredientPriceHistory.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>


          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Người xử lý hợp đồng xuất khẩu
              </CardHeader>
              <CardBody>
                <form onSubmit={formHandlerExternalContract.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.HANDLER_EXTERNAL_CONTRACT))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người xử lý hợp đồng<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formHandlerExternalContract.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formHandlerExternalContract.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Người quản lý đơn giá nguyên liệu
              </CardHeader>
              <CardBody>
                <form onSubmit={formHandlerIngredientPriceHistory.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.HANDLER_INGREDIENT_PRICE_HISTORY))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Người quản lý đơn giá nguyên liệu<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formHandlerIngredientPriceHistory.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={userOptions}
                                value={userOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formHandlerIngredientPriceHistory.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>
          {
            company === COMPANY_CODE.PN && <>
              <Col md={3} className={`mb-3`}>
                <Card>
                  <CardHeader className="bg-primary text-white">
                    Số ngày làm việc trong tháng của tài xế
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={formWorkingDayDriverPerMonth.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.WORKING_DAY_DRIVER_PER_MONTH))}>
                      <Row className="g-3">
                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="status">
                              Số ngày <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={formWorkingDayDriverPerMonth.control}
                                name="content"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    getInputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) => onChange(val.floatValue)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={formWorkingDayDriverPerMonth.errors}
                                name="content"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="12">
                          <Button color="primary" type="submit" disabled={loading}>
                            <span>Lưu</span>
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3} className={`mb-3`}>
                <Card>
                  <CardHeader className="bg-primary text-white">
                    Kiểm duyệt thu chi NCC/KH cty Phương Nam
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={formAssignReviewerPNCustomerMoneyFlow.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_PN_CUSTOMER_MONEY_FLOW))}>
                      <Row className="g-3">
                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="status">
                              Người kiểm duyệt<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={formAssignReviewerPNCustomerMoneyFlow.control}
                                name="content"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <ReactSelect
                                    isMulti
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={userOptions}
                                    value={userOptions.filter(
                                      (c) => {
                                        return value?.includes(c.value)
                                      }
                                    )}
                                    onChange={(val) => {
                                      onChange(val.map(e => e.value) || [])
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={formAssignReviewerPNCustomerMoneyFlow.errors}
                                name="content"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="12">
                          <Button color="primary" type="submit" disabled={loading}>
                            <span>Lưu</span>
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>

              </Col>

              <Col md={3} className={`mb-3`}>
                <Card>
                  <CardHeader className="bg-primary text-white">
                    Kiểm duyệt thu chi nhân viên/tài xế cty Phương Nam
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={formAssignReviewerPNStaffMoneyFlow.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_REVIEWER_PN_STAFF_MONEY_FLOW))}>
                      <Row className="g-3">
                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="status">
                              Người kiểm duyệt<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={formAssignReviewerPNStaffMoneyFlow.control}
                                name="content"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <ReactSelect
                                    isMulti
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={userOptions}
                                    value={userOptions.filter(
                                      (c) => {
                                        return value?.includes(c.value)
                                      }
                                    )}
                                    onChange={(val) => {
                                      onChange(val.map(e => e.value) || [])
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={formAssignReviewerPNStaffMoneyFlow.errors}
                                name="content"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="12">
                          <Button color="primary" type="submit" disabled={loading}>
                            <span>Lưu</span>
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>

              </Col>
              <Col md={3} className={`mb-3`}>
                <Card>
                  <CardHeader className="bg-primary text-white">
                    Kiểm duyệt vật tư
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={formAssignApproverMaterial.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.ASSIGN_APPROVE_MATERIAL))}>
                      <Row className="g-3">
                        <Col md="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="status">
                              Người kiểm duyệt<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={formAssignApproverMaterial.control}
                                name="content"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <ReactSelect
                                    isMulti
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={userOptions}
                                    value={userOptions.filter(
                                      (c) => {
                                        return value?.includes(c.value)
                                      }
                                    )}
                                    onChange={(val) => {
                                      onChange(val.map(e => e.value) || [])
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={formAssignApproverMaterial.errors}
                                name="content"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="12">
                          <Button color="primary" type="submit" disabled={loading}>
                            <span>Lưu</span>
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </Col>


            </>
          }
          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Hoa hồng mặc định cho nguyên liệu bán ra
              </CardHeader>
              <CardBody>
                <form onSubmit={formDefaultCommissionIngredientFeeExport.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.DEFAULT_COMMISSION_INGREDIENT_FEE_EXPORT))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Hoa hồng mặc định cho nguyên liệu bán ra<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formDefaultCommissionIngredientFeeExport.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <Table>
                                <thead>
                                  <tr>
                                    <th>Nguyên liệu</th>
                                    <th>Hoa hồng</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>BHD<span className="text-danger">*</span></td>
                                    <td>
                                      <NumericFormat
                                        className="form-control"
                                        value={value.BHD}
                                        thousandsGroupStyle="thousand"
                                        thousandSeparator=","
                                        decimalScale={0}
                                        onValueChange={(val) => onChange({ ...value, BHD: val.floatValue })}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>DTP<span className="text-danger">*</span></td>
                                    <td>
                                      <NumericFormat
                                        className="form-control"
                                        value={value.DTP}
                                        thousandsGroupStyle="thousand"
                                        thousandSeparator=","
                                        decimalScale={0}
                                        onValueChange={(val) => onChange({ ...value, DTP: val.floatValue })}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            )}
                          />
                          <ErrorMessage
                            errors={formDefaultCommissionIngredientFeeExport.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Content>
    </React.Fragment >
  );
};

export default Setting;
